<template>
  <div>
    <!-- page header -->
    <single-report-header :title="report.getTitle()" :date="date" />

    <!-- 1. aggregated bookings -->
    <aggregated-booking-helper
      :title="$t('singleReport.reservations')"
      :aggregated-bookings="aggregatedBookings"
    />

    <!-- events -->
    <aggregated-booking-helper
      :title="$t('singleReport.events')"
      :aggregated-bookings="events"
      class="mt-5"
    />

    <!-- groups -->
    <v-row v-if="extraRides.getRides().length" class="mt-5">
      <!-- groups -->
      <v-col class="col-12 py-0">
        <single-report-group-by-header :title="$t('singleReport.groups')" />
      </v-col>
      <v-col class="col-12 pt-0">
        <groups-helper :extra-rides="extraRides.getRides()" />
      </v-col>
    </v-row>

    <!-- no booking entries -->
    <v-row
      v-if="
        !events.length &&
        !aggregatedBookings.length &&
        !extraRides.getRides().length
      "
    >
      <v-col class="col-12 content-2">
        <span class="fal fa-folder-open mr-2" />
        {{ $t('singleReport.noContent') }}
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ReportMixin from '../ReportMixin'
import SingleReportHeader from '../SingleReportHeader'
import SingleReportGroupByHeader from '../SingleReportGroupByHeader'
import AggregatedBookingHelper from './AggregatedBookingHelper'
import GroupsHelper from './GroupsHelper'

export default {
  name: 'ReportNiesenOverview',
  components: {
    GroupsHelper,
    AggregatedBookingHelper,
    SingleReportGroupByHeader,
    SingleReportHeader,
  },
  mixins: [ReportMixin],

  computed: {
    aggregatedBookings() {
      return this.bookingAggregated
        .getAggregatedBookings()
        .filter((entry) => !entry.event)
    },

    events() {
      return this.bookingAggregated
        .getAggregatedBookings()
        .filter((entry) => entry.event)
    },
  },

  async mounted() {
    // via mixin
    // load grouped bookings
    this.loadAggregatedBookings()
    // load groups
    this.loadGroups()
  },
}
</script>
